import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20')
];

export const server_loads = [];

export const dictionary = {
		"/": [7],
		"/[locale=locale]/(login)": [20,[2,6]],
		"/[locale=locale]/(app)/(secure)/allowance": [8,[2,3,4]],
		"/[locale=locale]/(app)/(secure)/block": [9,[2,3,4]],
		"/[locale=locale]/(app)/(secure)/history": [10,[2,3,4,5]],
		"/[locale=locale]/(app)/(secure)/history/[uuid]": [11,[2,3,4,5]],
		"/[locale=locale]/(app)/(secure)/main": [12,[2,3,4]],
		"/[locale=locale]/(app)/(secure)/newsletter": [13,[2,3,4]],
		"/[locale=locale]/(app)/(secure)/settings": [14,[2,3,4]],
		"/[locale=locale]/(app)/(secure)/settings/passkeys": [15,[2,3,4]],
		"/[locale=locale]/(app)/(secure)/settings/passkeys/loginfaster": [16,[2,3,4]],
		"/[locale=locale]/(app)/(secure)/wallet/deposit": [18,[2,3,4]],
		"/[locale=locale]/(app)/(secure)/wallet/[[depositStatus]]": [17,[2,3,4]],
		"/[locale=locale]/(app)/welcome/[uuid]": [19,[2,3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';